import ContractLoader from "./ContractLoader"

export default ContractLoader
